import { Card, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const getTagColor = (rating) => {
  if (rating >= 4.5) return "green";
  if (rating >= 4.0) return "blue";
  if (rating >= 3.5) return "orange";
  return "red";
};

const columns = [
  {
    title: "Formular",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Durchschnittliche Bewertung",
    dataIndex: "avgRating",
    key: "avgRating",
    sorter: (a, b) => a.avgRating - b.avgRating,
    render: (rating) => (
      <Tag color={getTagColor(rating)}>{rating.toFixed(1)} / 5</Tag>
    ),
  },
  {
    title: "Anzahl Feedbacks",
    dataIndex: "feedbackCount",
    key: "feedbackCount",
    sorter: (a, b) => a.feedbackCount - b.feedbackCount,
  },
  {
    title: "Veränderung",
    key: "change",
    render: (_, record) => {
      if (!record.prevRating) return "-";
      const change = (record.avgRating - record.prevRating).toFixed(1);
      return (
        <span style={{ color: change >= 0 ? "green" : "red" }}>
          {change > 0 ? `+${change}` : change}
        </span>
      );
    },
  },
];

const FormRanking = ({ chartMetrics }) => {
  const { language } = useLanguage(); // für die Sprachwahl
  const text = dashboardContent[language].reports.analysis; // Holen der Texte für den Bereich "Reports"

  const [data, setData] = useState([]);

  useEffect(() => {
    if (
      !chartMetrics ||
      !chartMetrics.metrics ||
      !chartMetrics.metrics.formRanking
    ) {
      return; // Warten, bis Daten vorhanden sind
    }

    const formattedData = chartMetrics.metrics.formRanking.map((form) => ({
      key: form.id,
      name: form.name,
      avgRating: form.avgRating,
      feedbackCount: form.feedbackCount,
      prevRating: form.prevRating || form.avgRating,
    }));

    setData(formattedData);
  }, [chartMetrics]);

  return (
    <Card title={text.formRankingTitle} bordered={false} className="shadow-md">
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        className="overflow-x-scroll custom-scrollbar"
        locale={{
          emptyText: text.noFormsToRank,
        }}
      />
    </Card>
  );
};

export default FormRanking;
